<span @click="showModal">从投标报价导入</span>

<a-modal
  v-model:visible="visible"
  width="1000px"
  :keyboard="false"
  :centered="true"
  :mask-closable="false"
  @ok="ok"
  @cancel="closeModal"
>
  <template #title>
    <span>选择投标报价</span>
    <small class="text-grey ml10" v-if="needProjectId">仅展示已选项目下的投标报价</small>
  </template>
  <a-form layout="inline">
    <a-form-item>
      <a-input-search
        v-model:value.trim="queryRef.bidOfferBizNo"
        placeholder="请输入投标报价编号"
        style="width: 250px"
        enter-button
        allow-clear
        :loading="loading"
        @search="search"
      ></a-input-search>
    </a-form-item>
  </a-form>

  <a-table
    size="small"
    row-key="id"
    class="mt15"
    :bordered="true"
    :loading="loading"
    :data-source="dataSource"
    :pagination="pagination"
    :columns="columns"
    :scroll="{ x: 1100 }"
    :row-selection="{
      selectedRowKeys: selectedKeys,
      onChange: onSelectionChange,
      fixed: true,
      type: 'radio'
    }"
    @change="onTableChange"
  >
  </a-table>
</a-modal>
